import isEmpty from "lodash/isEmpty";
import { DetailsPanelData } from "PFApp/booking/components/details_panel";
import { Accordion } from "PFComponents/accordion";
import Hr from "PFComponents/hr";
import { ActivityWarningsIndex } from "PFCore/hooks/queries/activity";
import { Activity, Profile } from "PFTypes";
import { Fragment, RefObject } from "react";
import { useTranslation } from "react-i18next";

import { MisalignmentsDetail } from "./misalignments_detail/misalignments_detail";

type MisalignmentsDetailSidePanelContentProps = {
  data: DetailsPanelData;
  activities: Activity[];
  profiles: Profile[];
  warningsByActivity: ActivityWarningsIndex;
  sidePanelRef: RefObject<HTMLDivElement | null>;
};

export const MisalignmentsDetailSidePanelContent = ({
  data,
  activities,
  profiles,
  warningsByActivity,
  sidePanelRef
}: MisalignmentsDetailSidePanelContentProps) => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "details.misalignments" });
  const { goToDate } = data.bookingModuleDetails ?? {};

  if (activities.length === 1) {
    return (
      <MisalignmentsDetail
        profileId={data.misalignmentDetails?.profileId}
        profiles={profiles}
        misalignments={warningsByActivity[activities[0].id] ?? []}
        goToDate={data.misalignmentDetails?.enableGoToDate ? goToDate : undefined}
        sidePanelRef={sidePanelRef}
      />
    );
  }

  return (
    <>
      {activities
        .filter(({ id }) => !isEmpty(warningsByActivity[id]))
        .map(({ id, name }, index) => (
          <Fragment key={id}>
            {index !== 0 && <Hr />}
            <Accordion
              header={name}
              subtitle={t("id", { id })}
              iconSet="chevron"
              headerVariant="bodyBold"
              headerFullWidth
            >
              <MisalignmentsDetail
                key={id}
                profileId={data.misalignmentDetails?.profileId}
                profiles={profiles}
                misalignments={warningsByActivity[id] ?? []}
                goToDate={data.misalignmentDetails?.enableGoToDate ? goToDate : undefined}
                sidePanelRef={sidePanelRef}
              />
            </Accordion>
          </Fragment>
        ))}
    </>
  );
};
